import { render } from "./UniqueCallsToggle.vue?vue&type=template&id=67590912&scoped=true"
import script from "./UniqueCallsToggle.vue?vue&type=script&lang=js"
export * from "./UniqueCallsToggle.vue?vue&type=script&lang=js"

import "./UniqueCallsToggle.vue?vue&type=style&index=0&id=67590912&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-67590912"

export default script